import styled from 'styled-components'

export const RadioGroup = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 65%;
`
